import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchOrgChart = createAsyncThunk("fetchOrgChart", async (id) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`department/anc/list?id=${id}`, config);

	return response.data.data;
});

const orgChartSlice = createSlice({
	name: "orgChart",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchOrgChart.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchOrgChart.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchOrgChart.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default orgChartSlice.reducer;
